import {
  ISetAvailableFiltersAction,
  ISetAvailableFiltersPayload,
  ISetAvailableSortsAction,
  ISetAvailableSortsPayload,
  ISetFiltersAction,
  ISetFiltersPayload,
  ISetSortAction,
  ISetSortPayload,
} from "../types";

export type IActionTypes =
  | "SEARCH_SET_AVAILABLE_FILTERS"
  | "SEARCH_SET_AVAILABLE_SORTS"
  | "SEARCH_SET_FILTERS"
  | "SEARCH_SET_SORT";

export const actionTypes: { [key in IActionTypes]: key } = {
  SEARCH_SET_AVAILABLE_FILTERS: "SEARCH_SET_AVAILABLE_FILTERS",
  SEARCH_SET_AVAILABLE_SORTS: "SEARCH_SET_AVAILABLE_SORTS",
  SEARCH_SET_FILTERS: "SEARCH_SET_FILTERS",
  SEARCH_SET_SORT: "SEARCH_SET_SORT",
};

/**
 * set availableFilters
 */
export const setSearchAvailableFilters = (
  payload: ISetAvailableFiltersPayload
): ISetAvailableFiltersAction => ({
  payload,
  type: actionTypes.SEARCH_SET_AVAILABLE_FILTERS,
});

/**
 * set availableSorts
 */
export const setSearchAvailableSorts = (
  payload: ISetAvailableSortsPayload
): ISetAvailableSortsAction => ({
  payload,
  type: actionTypes.SEARCH_SET_AVAILABLE_SORTS,
});

/**
 * set filters
 */
export const setSearchFilters = (
  payload: ISetFiltersPayload
): ISetFiltersAction => {
  return {
    payload,
    type: actionTypes.SEARCH_SET_FILTERS,
  };
};

/**
 * set sort
 */
export const setSearchSort = (payload: ISetSortPayload): ISetSortAction => ({
  payload,
  type: actionTypes.SEARCH_SET_SORT,
});
